/**
 * Converts an object with string key-value pairs into a CSS-style string.
 *
 * @param obj - An object where keys are property names and values are their corresponding values.
 * @returns A string formatted as `key: value;` for each key-value pair in the object.
 *
 * @example
 * ```typescript
 * const styles = { color: 'red', 'font-size': '16px' };
 * const result = objectToString(styles);
 * console.log(result); // "color: red; font-size: 16px;"
 * ```
 */
const objectToString = (obj) => Object.entries(obj)
    .map(([key, value]) => `${key}: ${value}`)
    .join('; ');

export { objectToString };
